// MILES — tracking d'acquisition (point 41) : événements anonymes vers /api/analytics/event
const API = process.env.REACT_APP_BACKEND_URL;

export function trackEvent(event, extra = {}) {
  try {
    const lang = localStorage.getItem("miles-lang") || "fr";
    const device = window.innerWidth < 768 ? "mobile" : "desktop";
    fetch(`${API}/api/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event, lang, device,
        path: window.location.pathname,
        ref: document.referrer || "",
        ...extra,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* jamais bloquant */ }
}
